
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "getAtlasGeoMetadata",
      resolverType: "query",
      routePath: "/getAtlasGeoMetadata",
      httpMethod: "POST",
    });
  